var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOurValues1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.441,
    height: 83.058,
    viewBox: "0 0 78.441 83.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2{fill:#fff}.cls-1{stroke:#345e86;stroke-width:.5px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1542",
    transform: "translate(-366.322 -840.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6774",
    d: "M3.65 123.689H1.964v1.964H0v1.686h1.964v1.961H3.65v-1.964h1.964v-1.686H3.65z",
    className: "cls-1",
    transform: "translate(367.898 730.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6773",
    d: "M3.65 123.689H1.964v1.964H0v1.686h1.964v1.961H3.65v-1.964h1.964v-1.686H3.65z",
    className: "cls-1",
    transform: "translate(438.898 784.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6775",
    d: "M159.055 173.895v1.686h-1.686v-1.686zm0 3.372v1.686h-1.686v-1.686z",
    className: "cls-2",
    transform: "translate(224.309 666.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6779",
    d: "M159.055 173.895v1.686h-1.686v-1.686zm0 3.372v1.686h-1.686v-1.686z",
    className: "cls-2",
    transform: "translate(283.309 690.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6776",
    d: "M159.055 173.895v1.686h-1.686v-1.686zm0 3.372v1.686h-1.686v-1.686z",
    className: "cls-2",
    transform: "translate(270.309 744.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6777",
    d: "M32.166 53.325h1.686v1.686h-1.686z",
    className: "cls-2",
    transform: "translate(341.156 861.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6778",
    d: "M32.166 53.325h1.686v1.686h-1.686z",
    className: "cls-2",
    transform: "translate(334.156 863.314)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "target",
    transform: "translate(373.586 845.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6772",
    fill: "#fff",
    stroke: "#345f88",
    strokeWidth: "0.8px",
    d: "M59.028 16.4a2.4 2.4 0 0 0 1.7-.7l6.658-6.66a1.465 1.465 0 0 0-.943-2.5L62.9 6.322l2.312-2.312a.993.993 0 1 0-1.4-1.4l-2.317 2.307-.222-3.543a1.465 1.465 0 0 0-2.5-.943l-6.654 6.658a2.4 2.4 0 0 0-.7 1.85l.229 3.646A31.348 31.348 0 0 0 8.153 57.56a.993.993 0 0 0 1.47-1.337 29.372 29.372 0 0 1 41.784-41.218l-4.533 4.533A22.986 22.986 0 0 0 10.89 46.987a23 23 0 0 0 42.976-5.837.993.993 0 1 0-1.945-.4 21.014 21.014 0 0 1-39.266 5.33 20.74 20.74 0 0 1-2.326-9.6 20.993 20.993 0 0 1 35.14-15.531l-4.492 4.492a14.676 14.676 0 1 0 1.4 1.4l4.493-4.493a20.924 20.924 0 0 1 5.483 14 .993.993 0 0 0 .993.988h.006a.994.994 0 0 0 .988-1 22.905 22.905 0 0 0-6.064-15.4l4.533-4.533A29.372 29.372 0 0 1 12.88 59.3a.993.993 0 0 0-1.251 1.544 31.345 31.345 0 0 0 51.058-24.371A31.09 31.09 0 0 0 56.523 17.8q-.626-.843-1.3-1.637c3.894.245 3.684.234 3.807.234zM44.015 36.473a12.687 12.687 0 1 1-4.446-9.63l-4.521 4.521a6.324 6.324 0 1 0 1.405 1.4l4.521-4.521a12.617 12.617 0 0 1 3.041 8.23zm-13.374.7a.993.993 0 0 0 1.4 0l2.983-2.973a4.333 4.333 0 1 1-1.4-1.4l-2.978 2.978a.993.993 0 0 0 0 1.4zM53.4 8.814a.416.416 0 0 1 .121-.321l5.838-5.838.259 4.135-5.968 5.971zm1.653 5.352L61.027 8.2l4.135.259-5.838 5.838a.415.415 0 0 1-.321.121z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurValues1);
export default __webpack_public_path__ + "static/media/Our_Values_1.71c1c60623594951178cb105d85e93fa.svg";
export { ForwardRef as ReactComponent };